import React, { useState, useEffect } from "react";
import { FaVideo, FaVideoSlash } from "react-icons/fa";
import * as webRTCHandler from "../../utils/webRTCHandler";

const CameraButton = () => {
  const [isLocalVideoDisabled, setIsLocalVideoDisabled] = useState(true);

  useEffect(() => {
    // Check initial video state
    const stream = webRTCHandler.getLocalStream();
    if (stream && stream.getVideoTracks().length > 0) {
      setIsLocalVideoDisabled(!stream.getVideoTracks()[0].enabled);
    }
  }, []);

  const handleCameraButtonPressed = () => {
    const newVideoState = !isLocalVideoDisabled;
    webRTCHandler.toggleCamera(newVideoState);
    setIsLocalVideoDisabled(newVideoState);
  };

  return (
    <div className="video_button_container tooltip" onClick={handleCameraButtonPressed} data-tooltip={isLocalVideoDisabled ? "Start Video" : "Stop Video"}>
      <span className={`video_button_icon ${isLocalVideoDisabled ? 'muted' : ''}`}>
        {isLocalVideoDisabled ? (
          <FaVideoSlash size={20} />
        ) : (
          <FaVideo size={20} />
        )}
      </span>
      <span className="video_button_label">{isLocalVideoDisabled ? "Start Video" : "Stop Video"}</span>
    </div>
  );
};

export default CameraButton;
